import { Document, Page, pdfjs } from 'react-pdf';
import { Box, CircularProgress } from '@mui/material';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

// /*
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url
// ).toString();
// */
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface IProps {
  pdfFile: string;
  numPages: number;
  pageNumber: number;
  setNumPages: (numPages: number) => void;
  scale: number;
  scrollable?: boolean;
}

export const PdfDocument = ({
  pdfFile,
  setNumPages,
  numPages,
  pageNumber,
  scale,
  scrollable = false,
}: IProps) => {
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const styles = {
    width: '100%',
    '& .react-pdf__Page__canvas': {
      width: '100% !important',
      height: 'auto !important',
    },
  };

  if (scrollable) {
    return (
      <Box sx={scale === 1 ? styles : undefined}>
        <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              loading={<CircularProgress size={20} />}
              scale={scale}
            />
          ))}
        </Document>
      </Box>
    );
  }

  return (
    <Box sx={scale === 1 ? styles : undefined}>
      <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
        <Page
          pageNumber={pageNumber}
          loading={<CircularProgress size={20} />}
          scale={scale}
        />
      </Document>
    </Box>
  );
};
